import { Controller } from "@hotwired/stimulus";

// Drives the "Edit Certificate" modal. A single modal instance is shared across
// all certificate rows; the triggering dropdown item supplies the certificate
// context (slug + current printed details) via data attributes, which we read
// from the Bootstrap `show.bs.modal` event's relatedTarget.
export default class extends Controller {
  static targets = [
    "form", "recipientLabel",
    "recipientNameInput", "recipientTitleInput", "validThroughInput"
  ];

  static values = { baseUrl: String };

  connect() {
    this._boundShow = this.onShow.bind(this);
    this.element.addEventListener("show.bs.modal", this._boundShow);
  }

  disconnect() {
    this.element.removeEventListener("show.bs.modal", this._boundShow);
  }

  onShow(event) {
    const {
      certificateSlug, certificateRecipient,
      certificateRecipientTitle, certificateValidThrough
    } = event.relatedTarget?.dataset || {};
    if (!certificateSlug) return;

    // The list carries its filters in the query string, so posting them along
    // lands the admin back on the same filtered page after saving.
    this.formTarget.setAttribute(
      "action",
      `${this.baseUrlValue}/${certificateSlug}${window.location.search}`
    );
    this.recipientLabelTarget.textContent = certificateRecipient || "this practitioner";

    this._fill(this.recipientNameInputTarget, certificateRecipient);
    this._fill(this.recipientTitleInputTarget, certificateRecipientTitle);
    this._fill(this.validThroughInputTarget, certificateValidThrough);
  }

  // The input component's clear affordance keys off `input`, so a programmatic
  // write has to announce itself the way a keystroke would.
  _fill(input, value) {
    input.value = value || "";
    input.dispatchEvent(new Event("input"));
  }
}
